module.exports = __webpack_public_path__ + "static/media/login-image.a74dd4fe.png";